export default "__VITE_ASSET__Cai58wQX__"